<template>
    <div>
        <table width="100%" style="padding-left: 40px">
            <tr>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating" width="80%"  label="姓名" v-model="info.toUserName"/>
                </td>
                <td>
                    <DxDateBox display-format="yyyy-MM-dd" styling-mode="filled" label-mode="floating"  width="80%"  label="生日" v-model="info.birthday"/>
                </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating" width="80%"  label="手机号" v-model="info.phone"/>
                </td>
                <td>
                    <DxSelectBox  :items="simpleProducts" styling-mode="filled" label-mode="floating"  width="80%"  label="性别" v-model="info.sex"/>
                </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating" width="80%"  label="住址" v-model="info.address"/>
                </td>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating"  width="80%"  label="客户来源" v-model="info.customerSource"/>
                </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating" width="80%"  label="客户行业" v-model="info.customerIndustry"/>
                </td>
                <td>
                    <DxTextBox styling-mode="filled" label-mode="floating"  width="80%"  label="客户级别" v-model="info.customerLevel"/>
                </td>
            </tr>
        </table>
        <div align="center" style="margin-top: 50px">
            <DxButton @click="validateClick" text="提交" type="success" class="validate"/> &nbsp;
            <DxButton  type="danger" :use-submit-behavior="true" @click="close" text="关闭"/>
        </div>

    </div>
</template>

<script>
    export default {
        props:["byValue"],
        name: "CustomerUpdate",
        data() {
            return {
                info: {},
                simpleProducts:[
                    '男',
                    '女',
                    '未知',
                ],
            };
        },
        watch: {
            byValue: {
                handler(newVal, oldVal) {
                    if(this.byValue!=null){
                        this.$http.CustomerById({id:this.byValue}).then(res => {
                            this.info=res.data
                        })
                    }
                }
            }
        },
        created() {

        },
        methods:{
            validateClick(e) {
                const result = e.validationGroup.validate();
                if (result.isValid) {
                    this.$http.CustomerEdit(this.info).then(res => {
                        if(res.status == "error"){
                          this.$message({type: 'error', message: res.msg, center: true});
                        }else {
                            this.close()
                            this.$emit('refresh')
                          this.$message({type: 'success', message: res.msg, center: true});
                        }
                    })
                } else {
                  this.$message({type: 'warning', message: '请确认所有必填项都已填写', center: true});
                }
            },
            close(){
                // Object.keys(this.info).forEach(key => (this.info[key] = ''));
                this.$emit('close');
            }
        },
    }
</script>

<style scoped>

</style>